module.exports = __webpack_public_path__ + "assets/img/login-2.186e5b0f.gif";